import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column justify-content-center align-items-center" }

import { ref } from "vue";
import i18n from "@/core/plugins/i18n";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import SimpleForm from "@/components/SimpleForm.vue";
import FileUploader from "@/components/FileUploader2.vue";
import VerificationService from "@/projects/client/modules/verification/services/VerificationService";
import { VerificationDocumentTypes } from "@/core/types/VerificationInfos";
import UserService from "@/projects/tenant/modules/users/services/UserService";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentFileUploadModal',
  emits: ["refresh"],
  setup(__props, { expose: __expose, emit: emits }) {

const { t } = i18n.global;
const isLoading = ref(false);
const modelFormRef = ref<InstanceType<typeof SimpleForm>>(null);
const fileUploaderRef = ref<InstanceType<typeof FileUploader>>(null);

const fileForm = ref<FormData>();
const fileType = ref(VerificationDocumentTypes.Other);



const onFileUploaded = (_fileForm: any) => {
  fileForm.value = _fileForm;
  console.log("_fileForm", _fileForm);
};

const verificationId = ref(-1);
const show = async (id: number) => {
  verificationId.value = id;
  modelFormRef.value?.show();
  fileUploaderRef.value?.clearPreview();
};

const submitUploadReceipt = async () => {
  isLoading.value = true;
  try {
    const res = await UserService.uploadVerificationDocForUser(
      verificationId.value,
      fileType.value,
      fileForm.value
    );
    if (res) {
      MsgPrompt.success(t("tip.fileUploadSuccess")).then(() => {
        emits("refresh");
        modelFormRef.value?.hide();
      });
    }
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

__expose({
  show,
  hide: () => modelFormRef.value?.hide(),
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modelFormRef",
    ref: modelFormRef,
    title: _ctx.$t('title.fileUpload'),
    "is-loading": isLoading.value,
    submit: submitUploadReceipt
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.fileType')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              class: "w-300px",
              modelValue: fileType.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fileType).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: _ctx.$t('title.idFront'),
                  value: _unref(VerificationDocumentTypes).IdFront
                }, null, 8, ["label", "value"]),
                _createVNode(_component_el_option, {
                  label: _ctx.$t('title.idBack'),
                  value: _unref(VerificationDocumentTypes).IdBack
                }, null, 8, ["label", "value"]),
                _createVNode(_component_el_option, {
                  label: _ctx.$t('title.proofOfAddress'),
                  value: _unref(VerificationDocumentTypes).Address
                }, null, 8, ["label", "value"]),
                _createVNode(_component_el_option, {
                  label: _ctx.$t('title.additionalDocuments'),
                  value: _unref(VerificationDocumentTypes).Other
                }, null, 8, ["label", "value"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(FileUploader, {
          ref_key: "fileUploaderRef",
          ref: fileUploaderRef,
          title: '',
          onFileUploaded: onFileUploaded,
          "disable-default-upload": "",
          "disable-delete": ""
        }, null, 512)
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})